module.exports = __webpack_public_path__ + "components/flag/static/square/ma-19e3e1c8a954076816f1f12e98eb561e.svg";